var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentMapLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 548,
    viewBox: "0 0 548 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.667 25C182.667 11.1929 193.86 0 207.667 0H340.333C354.14 0 365.333 11.1929 365.333 25V182.667H182.667V25Z",
    fill: "#47FEFE",
    fillOpacity: 0.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182.667,
    y: 182.667,
    width: 182.667,
    height: 182.667,
    fill: "#00C2FF",
    fillOpacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 365.333,
    y: 365.333,
    width: 182.667,
    height: 182.667,
    rx: 50,
    fill: "#FF4003"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 182.667,
    height: 182.667,
    rx: 50,
    fill: "#FF4003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.667 365.333H365.333V523C365.333 536.807 354.14 548 340.333 548H207.667C193.86 548 182.667 536.807 182.667 523V365.333Z",
    fill: "#0085FF",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentMapLogo);
export default __webpack_public_path__ + "static/media/percentMapLogo.564285005e4ca3fc874f6ced97cc5e9a.svg";
export { ForwardRef as ReactComponent };